module.exports = __webpack_public_path__ + "static/media/YF01_6.9e493b99.jpg";